export default __webpack_public_path__ + "static/media/E-waste Resource Engineering _ Management.428d9b24.pdf";